module.exports = "<div class=\"ui container\">\n  <div class=\"ui warning icon message\">\n    <i class=\"lock icon\"></i>\n    <div class=\"content\">\n      <div class=\"header\">\n        Khu vực hạn chế truy cập\n      </div>\n      <div> Vui lòng <a (click)=\"auth.login()\">Đăng nhập</a> để tiếp tục\n      </div>\n      <br />\n      <div class=\"center aligned\">\n        <button class=\"ui mini blue button\" (click)=\"auth.login()\">Đăng nhập</button>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/home/home.component.html
// module id = ../../../../../src/app/shared/home/home.component.html
// module chunks = main